<script setup lang="ts">
import AppSidebar from "@/components/AppSidebar.vue"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"
import AppTopBar from "@/components/AppTopBar.vue"
import { RouterView } from "vue-router"
import { usePageHeader } from "@/composables/usePageHeader"
import { usePageActions } from "@/stores/pageActions"
import { storeToRefs } from "pinia"
import HeaderActions from "@/components/HeaderActions.vue"

const { title, description, breadcrumb } = usePageHeader()
const { items } = storeToRefs(usePageActions())
</script>

<template>
  <SidebarProvider>
    <AppSidebar />
    <SidebarInset>
      <AppTopBar
          :breadcrumb="breadcrumb"
          :title="title"
          :description="description"
          :showPageHeader="true"
      >
        <!-- ações do topo (se quiser) -->
        <template #header-right></template>

        <!-- ações do page header -->
        <template #page-header-right>
          <HeaderActions :items="items" />
        </template>
      </AppTopBar>

      <main class="flex flex-1 flex-col gap-4 p-4">
        <RouterView />
      </main>
    </SidebarInset>
  </SidebarProvider>
</template>
